import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-zinc-900 border border-white/10 rounded-sm p-3 shadow-xl">
        <p className="text-xs text-zinc-400 mb-1">{label}</p>
        <p className="text-lg font-bold text-white">
          Rp {Math.round(payload[0].value).toLocaleString('id-ID')}
        </p>
      </div>
    );
  }
  return null;
};

export function RevenueChart({ data }) {
  const revenues = Array.isArray(data) ? data.map((item) => Number(item.revenue) || 0) : [];
  const minRevenue = revenues.length ? Math.min(...revenues) : 0;
  const maxRevenue = revenues.length ? Math.max(...revenues) : 0;
  const range = maxRevenue - minRevenue;
  const padding = range > 0 ? range * 0.2 : Math.max(maxRevenue * 0.2, 100000);
  const yDomain = [
    Math.max(0, Math.floor(minRevenue - padding)),
    Math.ceil(maxRevenue + padding),
  ];

  return (
    <div 
      className="bg-zinc-900/50 border border-white/10 rounded-sm p-6"
      data-testid="revenue-chart"
    >
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-white tracking-tight">Revenue Overview</h3>
        <p className="text-xs text-zinc-500 mt-1">Monthly revenue for the past 6 months</p>
      </div>
      
      <div className="h-[280px]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 20, left: 10, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
            <XAxis 
              dataKey="month" 
              axisLine={false}
              tickLine={false}
              height={24}
              tick={{ fill: '#71717A', fontSize: 12 }}
            />
            <YAxis 
              axisLine={false}
              tickLine={false}
              domain={yDomain}
              tick={{ fill: '#71717A', fontSize: 12 }}
              tickFormatter={(value) => `${(value / 1000000).toFixed(1)}jt`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Line
              type="monotone"
              dataKey="revenue"
              stroke="#D4AF37"
              strokeWidth={2}
              dot={{ fill: '#D4AF37', strokeWidth: 0, r: 4 }}
              activeDot={{ r: 6, fill: '#D4AF37', stroke: '#09090B', strokeWidth: 2 }}
              style={{ filter: 'drop-shadow(0 0 8px rgba(212, 175, 55, 0.4))' }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
